import { render, staticRenderFns } from "./TagsChip.vue?vue&type=template&id=0c85cfb6"
import script from "./TagsChip.vue?vue&type=script&lang=js"
export * from "./TagsChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports